const GetPeopleCall = (geId: any) => {
  return `query{
    getpeopleInformation(geId:"${geId}"){
        edgeUid
        createdDate
        username
        firstName
        lastName    
        email
        contactPreference
        softPhoneId
        phone1
        country
        cityId
        orgId
        phone2
        isEmailVerified
        managerEmail
        language
        accountId
        status
        token
        accountName
        orgName
        license
        {
          productId
          productName
          isDemoLicense
          organizationDetail {
            emailFeatureSettings {
              emailFeatureName
              status
            }
          }
          licenseId
          startDate
          endDate
          active
        }
        serviceConfiguration
        {
            features
        }       
        orgLogoPath 
      }
  }`;
};

const GetTermsData = `query getterm {
  getAgreements(id: "1")
  }`;

const GetAllTestProgress = `query GetAllTestProgress($userId: Int!, $orgId: Int!){
    getAllTestProgress(userId: $userId, orgId: $orgId)
  }`;

const SetTermsData = (geId: string, id: string) => {
  return `mutation agree{
    updateAgreement(geId: "${geId}" id:"${id}")    
  }`;
};

const GetCountriesList = `query {
  getCountries {
    countryCode
    countryName
    countryISDCode
    updated
  }
}`;

const GetStatesList = (countryCode: string) => {
  return `query {
    getStates(countryCode: "${countryCode}") {
     stateId
     stateName
     stateCode
     countryCode    
    }
  }`;
};

const GetCitiesList = (countryCode: string, stateCode: number) => {
  return `query { 
    getCities(countryCode: "${countryCode}", stateCode: "${stateCode}") {
      cityId
      cityName
      stateCode
      stateName
      timezone    
    }
  }`;
};

const GetLearnerJwtoken = `query GetLearnerJwtoken($geId: Int, $edgeUid: Int, $username: String!, $uuId: String!, $iss: String!){
  getLearnerJwtoken(geId:$geId, edgeUid:$edgeUid, username:$username, uuid:$uuId, iss:$iss)
}`;

const GetTMSGetCourse = `query GetTMSGetCourse($uuId : String!) {
  getTMSGetCourse(uuId :$uuId ) {
    courseId
    status
    courseName
    trainingType
    language
  }
}`;

// For elevate my progress
const GetElevateAssessmentDetails = `query GetElevateAssessmentDetails($LanguageAssessed: String!, $Level: String!){
  getElevateAssessmentDetails(LanguageAssessed: $LanguageAssessed, Level: $Level)
}`;

const GetTestScoreValues = `query GetTestScoreValues($userId: Int!, $testContentId: String!){
  getLearnerTestProgress(userId: $userId, testContentId: $testContentId)
}`;
// End of elevate my progress queries

const UpdateTimezoneTms = `query UpdateTimezoneTms($uuId: String, $data: TMSLearner) {
  getTMSUpdateLearner(uuId: $uuId, data: $data) {
    guid
    id
  }
}`;

const GetLearnerTasks = (userID: string) => {
  return `query{
      getLearnerTasks(id:"${userID}")
      {
        taskid
        licenseId
        status
        isexists
        isparallel       
      }
    }`;
};

const UpdateNewPasswordPeople = (geId: string, newPassword?: string) => {
  return `    
    mutation {
    updatePeopleInformation(geId:"${geId}",
    params:{password:"${newPassword}"   
  }
    )
      {
        firstName
        lastName
      }
    }`;
};

const UpdatePasswordPeople = (geId: string, oldPassword: string, newPassword?: string) => {
  return `    
    mutation {
    updatePeopleInformation(geId:"${geId}",
    params:{oldPassword:"${oldPassword}",
    password:"${newPassword}"   
  }
    )
      {
        firstName
        lastName
      }
    }`;
};

const GetCustomFields = (orgId: number) => {
  return `query
  {
    getOrganizationCustomFields(OrgId:${orgId})
  }`;
};

const SendForgotEmail = (emailInput: string) => {
  return `query
  {
    sendForgotPasswordEmail(email:"${emailInput}")
    {
      message
    }
  }`;
};

const SetLearnerInfoPeople = (geId: string, userInfo: any, transLang?: string) => {
  return `    
    mutation {
    updatePeopleInformation(geId:"${geId}",
    params:{firstName:"${userInfo.firstName}",
    lastName:"${userInfo.lastName}",
    country:"${userInfo.country}",
    cityId:"${userInfo.cityId}",
    email:"${userInfo.email}",
    contactPreference:"${userInfo.contactPreference}",
    softPhoneId:"${userInfo.softPhoneId}",
    phone1:"${userInfo.phone1}",
    phone2:"${userInfo.phone2}"
    ${userInfo.managerEmail ? `managerEmail: "${userInfo.managerEmail}"` : ""},
    ${userInfo.confirmProfile ? `confirmProfile: "${userInfo.confirmProfile}"` : ""},    
    language:"${transLang}",   
  }
    )
      {
        firstName
        lastName
        country
        cityId
        email
        contactPreference
        softPhoneId
        phone1
        phone2
      }
    }`;
};

const SetLearnerTask = (edgeUid: string, status: boolean, taskID: string, lastUpdateDateTime?: string) => {
  if (lastUpdateDateTime) {
    return `mutation add {
        createLearnerTask(input:{Id:"${edgeUid}",TaskId:"${taskID}",Status:${status},LastUpdate:"${lastUpdateDateTime}"})
        {
         Id
         TaskId
         Status   
        }
      }`;
  } else {
    return `mutation add {
        createLearnerTask(input:{Id:"${edgeUid}",TaskId:"${taskID}",Status:${status}})
        {
         Id
         TaskId
         Status  
        }
      }`;
  }
};

const UpdateLearnerTask = (edgeUid: string, status: boolean, taskID: string, lastUpdateDateTime?: string) => {
  if (lastUpdateDateTime) {
    return `mutation add {
        updateLearnerTask(input:{Id:"${edgeUid}",TaskId:"${taskID}",Status:${status},LastUpdate:"${lastUpdateDateTime}"})
        {
         Id
         TaskId
         Status   
        }
      }`;
  } else {
    return `mutation add {
        updateLearnerTask(input:{Id:"${edgeUid}",TaskId:"${taskID}",Status:${status}})
        {
         Id
         TaskId
         Status       
        }
      }`;
  }
};

const getTMSLearnerSessions = (uuId: string) => {
  return `query{
    getTMSLearnerSessions(uuId:"${uuId}")
    {
      id
    status
    sessionType
    sessionCalendarType
    location
    sessionLocation
    label
    startTime
    endTime
    course
    students
    {
    status
    name
    id
    guid
    role
    organization 
    {
      name
      id
    }
    classroomLink
    }
    teacher
    {
    name
    id
    role
    organization  
    }
    teacherComment
    }
  }`;
};

const GetTMSLearnerSessions = `query getTMSLearnerSessions($uuId : String!)
{
getTMSLearnerSessions(uuId :$uuId )
{
  id
status
sessionType
sessionCalendarType
location
sessionLocation
label
startTime
endTime
course
students
{
name
id
guid
role
organization 
{
  name
  id
}
classroomLink
}
teacher
{
name
id
role
organization  
}
teacherComment
}
}`;
const CreateSessionService = `query createSessionService($courseId : Int!)
{
createSessionService(courseId :$courseId )
{
  id
  name
  length
  statistics
  
  {
      lostSessions
      upcomingSessions
      openSessions
      finishedSessions
  }
  hasTeacher
}
}`;

const Sendverification = `mutation Sendverification($learnerToken: String!, $userId:String , $email:String ){
  sendOTP(learnerToken:$learnerToken, userId:$userId, email:$email)
}`;

const VerifyEmail = `mutation VerifyEmail($learnerToken: String!, $userId:String , $code:String ){
  verifyEmail(learnerToken:$learnerToken, userId:$userId, code:$code)
}`;

const GetCourse = `query getCourse($uuId : String!)
{
  getTMSLearnerCourse(uuId :$uuId )
{
  courseId
  status  
  courseName
  trainingType
}
}`;

const getTMSAssignments = (sessionId: string, learnerToken: string) => {
  return `query{
    getTMSAssignments(sessionId:"${sessionId}", learnerToken:"${learnerToken}")
    {
      assignments
      {
        type
        name
        url
      }
      instructions
    }
  }`;
};

const GetElevateHomeWorkDetails = `query getElevateHomeWorkDetails($sessionIds: String!){
  getElevateHomeWorkDetails(sessionIds: $sessionIds)
}`;

const GetHandoutDetails = `query getElevateHandoutDetails($sessionIds: String!){
  getElevateHandoutDetails(sessionIds: $sessionIds)
}`;

const GetlearnerFeedback = `query getLearnerFeedback($learnerToken : String!){
  getLearnerFeedback(learnerToken :$learnerToken )
}`;

const getLearnerFeedback = (learnerToken: string) => {
  return `query {
    getLearnerFeedback(learnerToken: "${learnerToken}")
  }`;
};

const Createfeedback = `mutation createFeedback($SessionId : Int!,$UserType :String!,$UUID : String!, $Source : String!, $Rating : Int!, $Comment : String!, $Reasons : [String], $learnerToken : String!)
{
  createFeedback(input: {SessionId :$SessionId, UserType : $UserType,UUID : $UUID,Source : $Source,Rating : $Rating, Comment : $Comment, Meta:[{Reasons: $Reasons}]},learnerToken : $learnerToken )
}`;

const GetLearnerSessionsById = `query getLearnerSessionsById($id : String!) {
  getLearnerSessionsById(id:$id)
  {
    Id
    SessionId
    StartTime
    EndTime
    UnitId
    IsRatingGiven
  }
}`;

const UpdateTmsLearnerSession = `mutation add($Id: String!, $UnitId: String!, $SessionId: Int!, $StartTime: Int!, $EndTime: Int!, $Status: Int!, $IsRatingGiven: Boolean ) {
  updateLearnerSessions(input:{Id: $Id, UnitId: $UnitId, SessionId: $SessionId, StartTime: $StartTime, EndTime: $EndTime, Status: $Status, IsRatingGiven: $IsRatingGiven})
  {
   Id
   UnitId
   SessionId
   StartTime
   EndTime
   Status
   IsRatingGiven
  }
}`;

const CancelSessionTMS = `mutation cancelSessionTMS($learnerToken : String!, $sessionId: String!) 
{
  cancelSessionTMS(learnerToken :$learnerToken,sessionId : $sessionId )

}`;

const GetTmsCalendarEvent = `query GetTmsCalendarEvent($courseId: String!){
  getTMSCalendarEvents(courseId: $courseId) {
  numberOfPages
  records
  {
    id
    status
    perWeekFrequency
    maxPerWeekFrequency
    createdAt
    course
    {
      referenceId
    }
    participants
    {
      id
      referenceId
    }
  }
  }
  }`;

const GetTmsLearnerAvailability = `query GetTmsLearnerAvailablity($patId: String!){
    getTMSLearnerAvailablity(patId:$patId) {
    currentPage
    numberOfPages
    records
    {
      fromTimestamp
      toTimestamp
    }
    }
    }`;

const GetAnnouncements = `query getAnnouncements($userId: String!) {
      getAnnouncements(userId: $userId) {
          hashKey
          announcement
      }
  }`;

const GetSkillsProgress = `query getSkillsReport($userId : Int!){
  getSkillsReport(userId : $userId) {
      skilltitle
      skillcourses
      {
        accountid
        skillid
        skilltitle
        subskilltitle
        userid
        subskillid
        sessionid
        totalprework
        preworkcompleted
        totalhomework
        homeworkcompleted
        reviewcompleted
        totalsession
        sessioncompleted
        sessioncompleteddate
      }
    }}`;

const GetReachProgress = `query getReachProgress($userId: Int!, $orgId: Int!, $token: String!){
  getReachReport(userId: $userId, orgId: $orgId, token: $token)
}`;

const GetCurrentCourseDetails = (
  userId: string,
  licenseId: string,
  productId: number,
  uuId: string,
  course: number,
) => {
  return `query{
    getCurrentCourseDetails(userId:"${userId}", licenseId:"${licenseId}", productId:${productId}, uuId:"${uuId}", course:${course})
  }`;
};

const GetCurrentSoloCourseDetails = (userId: string, licenseId: string, productId: number) => {
  return `query{
    getCurrentSoloCourseDetails(userId:"${userId}", licenseId:"${licenseId}", productId:${productId})
  }`;
};

const GetNewsFeedData = () => {
  return `query LPContentSuggest{
    lpSuggest{
      UUID
      Url
      Source
      Author
      Category
      Title
      Content
      Summary
      ImageUrl
      Tags
      Keywords
      PublishedDate
      Readtime
    }
  }`;
};

const GetSpintLevelQuery = (userID: number) => {
  return `
  {
    userskillscourseslist(params: {userId: ${userID}
  }) {
      skilltitle
      userid
      username
      skilllevel
      skillcourses {
        accountid
        skillid
        userid
        skilltitle
        subskilltitle
        subskillid
        sessionid
        totalprework
        preworkcompleted
        totalhomework
        homeworkcompleted
        reviewcompleted
        totalsession
        sessionstatus
        sessioncompleted
        sessionstarteddate
        sessioncompleteddate
        trainername
        duration
        comment
        rating
        skilltypeid
        courseparttitle
      }
    }
  }
  `;
};

const GetRenewalDate = (userId: number) => {
  return `query{
    getRenewalDate(userId:${userId})
  }`;
};

const PostRenewalData = (userId: number, status: number) => {
  return `mutation{
    postRenewalData(userId:${userId}, status : ${status})
  }`;
};

const putCustomFields = (geId: string, customFields: any) => {
  return `mutation{
    updateCustomFields(input:{geId:"${geId}",customFields:"${customFields}"})
   }`;
};

const GetActivitySummaryReport = (
  userId: string,
  productId: number,
  eventType: string,
  orgId: string,
  filterBy: string,
) => {
  return `query {
    getProgressDetails(
      userId: "${userId}", 
      productId: ${productId}, 
      eventType: "${eventType}",
      orgId: "${orgId}",
      filterBy: "${filterBy}"
    )
  }`;
};

const GetLearnerProgressDetails = (userId: string, productId: number, eventType: string) => {
  return `query {
    getProgressDetails(userId: "${userId}", productId: ${productId}, eventType: "${eventType}")
  }`;
};

const soloProgressDetails = (userId: number, productId: number) => {
  return `query 
  {
    soloProgressDetails(params: { userId:${userId}, productId:${productId} }) {
      moduleName
      moduleId
      moduleOrder
      curriculum
      curriculumId
      courseName
      coursePartTitle
      units {
      orgId
      userId
      licenseId
      productId
      curriculumId
      curriculum
      courseId
      courseName
      moduleId
      moduleName
      moduleOrder
      unitId
      unitName
      unitType
      unitOrder
      questionTotal
      questionComplete
      questionCorrect
      moduleCompleted
      activityCompleted
      totalActivity
      coursePartTitle
      }
      
  }
  }`;
};
const GetLearnerDetails = `query GetLearnerDetails($userId:String!,$productId: Int!){
  getLearnerInfo(userId:$userId,productId:$productId){
    UserId
    ProductId
    Level
    LevelType
    CourseLevel
    LevelChange
    Comments
  }
}`;

const GetOtherTasks = (userID: string, productId: number) => {
  return `query{
      getLearnerTasks(id:"${userID}",productId:${productId})
      {
        taskid
        licenseId
        status
        isexists
        isparallel       
      }
    }`;
};

const GetVocabularyContents = `query GetVocabularyContents($geId: String!,$token: String!,$accountId: Int!){
    getVocabularyContents(geId:$geId, token:$token, accountId:$accountId)
}`;

const GetVocabularyWordList = `query GetVocabularyWordList($geId: String!,$token: String!,$wordListId: String!,$customFieldValue: String!,$language: String!){
  getVocabularyWordList(geId:$geId, token:$token, wordListId:$wordListId, customFieldValue:$customFieldValue, language:$language)
}`;

const GetVocabularySearchedWord = `query GetVocabularySearchedWord($geId: String!, $token: String!, $searchedText: String!, $userType: String!, $isCaseSensitive: Int!){
  getVocabularySearchedWord(geId:$geId , token:$token , searchedText:$searchedText , userType:$userType , isCaseSensitive:$isCaseSensitive )
}`;

const CreateVocabularyNewWordList = `mutation CreateVocabularyNewWordList($token: String!, $newWordListTitle: String!, $userType: String!){
  vocabularyCreateNewWordList(token:$token , newWordListTitle:$newWordListTitle, userType:$userType)
}`;

const EditNoteForWord = `mutation EditNoteForWord($token: String!, $defId: String!, $definition: String!, $sentence: String!, $note: String!, $slang: Int!, $posId: Int!){
  vocabularyEditNote(token:$token , defId:$defId , definition:$definition , sentence:$sentence , note:$note , slang:$slang , posId:$posId )
}`;

const UpdateWordToWordList = `mutation UpdateWordToWordList($token: String!, $wordListId: String!, $wordId: String!, $type: String!, $action: String!, $wordlist: String!){
  vocabularyAddWordToWordList(token:$token , wordListId:$wordListId , wordId:$wordId , type:$type , action:$action , wordlist:$wordlist )
}`;

const CreateWordAndAddToWordList = `mutation CreateWordAndAddToWordList($token: String!, $def: String!, $listId: String!, $posId: String!, $pos: String!, $sentence: String!, $slang: Int!, $word: String!, $type: String!, $translation: String, $note: String){
  vocabularyAddNewWord(token:$token , def:$def , listId:$listId , posId:$posId , pos:$pos , sentence:$sentence , slang:$slang , word:$word , type:$type , translation:$translation , note:$note )
}`;

const EditWordList = `mutation EditWordList($token: String!, $wordListId: String!, $newTitle: String!, $userType: String!){
  vocabularyEditWordList(token:$token , wordListId:$wordListId , newTitle:$newTitle , userType:$userType )
}`;

const DeleteWordFromWordList = `mutation DeleteWordFromWordList($token: String!, $wordListId: String!, $wordId: String!, $userType: String!){
  vocabularyDeleteWordFromWordList(token:$token , wordListId:$wordListId , wordId:$wordId , userType:$userType )
}`;

const DeleteWordList = `mutation DeleteWordList($token: String!, $wordListId: String!){
  vocabularyDeleteWordList(token: $token, wordListId: $wordListId)
}`;

const GetMySounds = `query GetMySounds($userId: String!){
  getMySounds(userId: $userId)
}`;

const GetLearnerProgressBloom = `query GetLearnerProgressBloom($geId: String!, $nodeId: String!){
  getLearnerProgressBloom(geId: $geId, nodeId: $nodeId)
}`;

const GetLearnerNewProgress = `query getLearnerProgressDetails($uId:String!, $level: String!, $productId: Int!, $language: String)
{
  getLearnerProgressDetails(UserId: $uId, Level: $level, ProductId: $productId, LanguageCode: $language)
}`;

const haloSessionTos = `mutation haloSessionTos($UserId: String!, $eventType: String) {
  haloSessionTos( UserId: $UserId, eventType: $eventType )
}`;

const getMyProgressDetails = (
  userID: string,
  level: string,
  productId: number,
  moduleId: string,
  LanguageCode?: string,
) => {
  return `query{
    getLearnerProgressReport(userId:"${userID}",level:"${level}",productId:${productId},moduleId:"${moduleId}",LanguageCode:"${LanguageCode}")}`;
};

const getCourseList = (uuId: string, userID: string, course: number, productId: number, licenseId: string) => {
  return `query{
    getCourseList(uuId:"${uuId}",userId:"${userID}",course:${course},productId:${productId},licenseId:"${licenseId}")}`;
};

const getJsonTemplate = (classId: number, activityId: number, valueId: number, title: string, template: string) => {
  return `query{
    getProductivityToolDetails(classId:${classId},activityId:${activityId},valueId:${valueId},title:"${title}",template:"${template}")}`;
};

const getLearnersStepAuthorize = (getUserToken: string) => {
  return `query{
    learnersStepAuthorize(getUserToken:"${getUserToken}")}`;
};
const getLearnersStepResult = (sessionId: string, attemptId: string, userId: string, getUserToken: string) => {
  return `query{
    learnersStepResult(sessionId:"${sessionId}",attemptId:"${attemptId}",userId:"${userId}",getUserToken:"${getUserToken}")}`;
};

export {
  getLearnersStepAuthorize,
  getLearnersStepResult,
  getJsonTemplate,
  getCourseList,
  getMyProgressDetails,
  GetLearnerTasks,
  SetLearnerTask,
  UpdateLearnerTask,
  GetPeopleCall,
  SetLearnerInfoPeople,
  GetCountriesList,
  GetStatesList,
  GetCitiesList,
  GetLearnerJwtoken,
  GetTMSGetCourse,
  GetElevateAssessmentDetails,
  GetTestScoreValues,
  GetTMSLearnerSessions,
  CreateSessionService,
  GetTermsData,
  GetCourse,
  GetlearnerFeedback,
  Createfeedback,
  SetTermsData,
  UpdateTimezoneTms,
  Sendverification,
  VerifyEmail,
  getTMSAssignments,
  GetHandoutDetails,
  GetElevateHomeWorkDetails,
  GetLearnerSessionsById,
  UpdateTmsLearnerSession,
  UpdatePasswordPeople,
  GetCustomFields,
  CancelSessionTMS,
  GetTmsCalendarEvent,
  GetTmsLearnerAvailability,
  SendForgotEmail,
  GetAnnouncements,
  GetNewsFeedData,
  UpdateNewPasswordPeople,
  GetSkillsProgress,
  GetReachProgress,
  GetSpintLevelQuery,
  GetAllTestProgress,
  GetCurrentCourseDetails,
  GetRenewalDate,
  PostRenewalData,
  getTMSLearnerSessions,
  getLearnerFeedback,
  GetActivitySummaryReport,
  putCustomFields,
  GetCurrentSoloCourseDetails,
  soloProgressDetails,
  GetLearnerDetails,
  GetOtherTasks,
  GetVocabularyContents,
  GetVocabularyWordList,
  GetVocabularySearchedWord,
  CreateVocabularyNewWordList,
  EditNoteForWord,
  UpdateWordToWordList,
  CreateWordAndAddToWordList,
  EditWordList,
  DeleteWordFromWordList,
  DeleteWordList,
  GetMySounds,
  GetLearnerProgressBloom,
  GetLearnerProgressDetails,
  GetLearnerNewProgress,
  haloSessionTos,
};
